export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/hr_consulting.b51dabc.svg";